export type ResetTimer = {
  durationSeconds: number
  startedAtMs: number
}

export function createResetTimer(expiresIn: unknown, startedAtMs = Date.now()): ResetTimer | null {
  const durationSeconds = Number(expiresIn)
  if (!Number.isFinite(durationSeconds) || durationSeconds <= 0) return null

  return {durationSeconds: Math.ceil(durationSeconds), startedAtMs}
}

export function resetTimerFromSearch(params: URLSearchParams): ResetTimer | null {
  const startedAtMs = Number(params.get('timer_started_at'))
  if (!Number.isFinite(startedAtMs) || startedAtMs <= 0) return null

  return createResetTimer(params.get('expires_in'), startedAtMs)
}

export function resetTimerQuery(timer: ResetTimer | null): string {
  if (!timer) return ''

  return `&expires_in=${timer.durationSeconds}&timer_started_at=${timer.startedAtMs}`
}

export function resetSecondsRemaining(timer: ResetTimer | null, nowMs = Date.now()): number | null {
  if (!timer) return null

  const endsAtMs = timer.startedAtMs + timer.durationSeconds * 1000
  return Math.max(0, Math.ceil((endsAtMs - nowMs) / 1000))
}
